import { useSearchParams, Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import "../HomePage.scss";

export default function TopBar() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { t } = useTranslation(["page"]);
  const ver = searchParams.get("ver") || "1";
  const BROWSERLANGUAGE = i18next.language;
  const location = useLocation();

  return (
    <div className="topbar">
      <div className="section-content">
        <div className="top-bar-container flex-row">
          <a href="/">
            <img className="image-logo" src="images/newhome/logo_text.webp" />
          </a>
          <div className="links">
            {/* {location.pathname == "/" ? null : (
            <Link to="/" style={{ textDecoration: "none", color: "white" }}>
              <span> {t(`v${ver}.TopBar.link-home`)}&nbsp;&nbsp;&nbsp;</span>
            </Link>
          )} */}
            {/* <Link
              to="/contact"
              style={{ textDecoration: "none", color: "white" }}
            >
              <span> Contact </span>
            </Link> */}
          </div>
          {/* <div className="top-bar-image">
          <img src="images/pre-order.webp" alt="pre-order-icon"></img>
        </div> */}
          {/* <button
          className="pre-order-button"
          type="button"
          onClick={onPreOrderClick}
        >
          Last Pre-order
        </button> */}
          {/* <div className="pre-order-text">Last pre-order ></div> */}
        </div>
      </div>
    </div>
  );
}
